// Print a PDF fetched from the server (e.g. a QuickBooks invoice). fetchPdf returns a Blob.
// Throws the fetch error so the caller can show it.
export const printPdf = async (fetchPdf) => {
  // Phones and Safari can't print a PDF from a hidden frame, so they get it in a new tab
  // (opened now, before the download, so it isn't blocked as a pop-up)
  const ua = navigator.userAgent;
  const useNewTab = /Android|iPhone|iPad|iPod|Mobile/i.test(ua) || (/Safari/.test(ua) && !/Chrome|Chromium|Edg/.test(ua));
  const pdfWindow = useNewTab ? window.open('', '_blank') : null;

  let pdf;
  try {
    pdf = await fetchPdf();
  } catch (error) {
    if (pdfWindow) pdfWindow.close();
    throw error;
  }
  const url = URL.createObjectURL(new Blob([pdf], { type: 'application/pdf' }));
  if (pdfWindow) {
    pdfWindow.location.href = url;
  } else {
    const frame = document.createElement('iframe');
    frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
    frame.src = url;
    frame.onload = () => {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    };
    document.body.appendChild(frame);
    // Leave time for the print dialog before cleaning up
    setTimeout(() => { frame.remove(); URL.revokeObjectURL(url); }, 60000);
  }
};
